import React from 'react';
import { useEffect, useState } from 'react';
import { Api, SendEmail } from './interface';
import Modal from 'react-bootstrap/Modal';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Hint, TRANSACTION_STATUS } from './constants';
import { Button, Form, ModalBody, ModalFooter } from 'react-bootstrap';
import { PlusLg, Trash } from 'react-bootstrap-icons';
import { bake } from './common';
import { GeekApi } from './interface';
import { toast } from 'react-toastify';
import { CheckAll } from 'react-bootstrap-icons';
import { IsRole } from './validator';
import BrotherSdk from 'bpac-js';

export default function PutAwayOrder(props) {
  const [users, setUsers] = useState([]);
  const [list, setList] = useState(props.list);
  const [currentOwner, setCurrentOwner] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [locations, setLocations] = useState([]);
  const [buildIds, setBuildIds] = useState([]);
  const [selectedBuildIds, setSelectedBuildIds] = useState([]);
  const [remainingBuildIds, setRemainingBuildIds] = useState([]);
  const [allSrNos, setAllSrNos] = useState([]);
  const [selectedSrNos, setSelectedSrNos] = useState([]);
  const [remainingSrNos, setRemainingSrNos] = useState([]);
  const [skuList, setskuList] = useState([]);
  const [comment, setComment] = useState(null);
  const [initRequestComment, setInitRequestComment] = useState(null);
  const [newBoxFlag, setNewBoxFlag] = useState(true);
  const [disableSave, setDisableSave] = useState(true);
  const [initSkuList, setInitSkuList] = useState(true);
  const [updateFlag, setUpdateFlag] = useState(null);

  // brother printer sdk
  const [brotherPrinterSdk, setBrotherPrinterSdk] = useState(undefined);
  const [brotherPrinterFound, setBrotherPrinterFound] = useState(false);
  const [printLabelButtonEnabled, setPrintLabelButtonEnabled] = useState(true);
  const templatePath = `${window.location.origin}/MaterialStorageTemplate.lbx`;

  const [trId, setTrId] = useState(undefined);
  const [errorModal, setErrorModal] = useState(false);
  const [userAction, setUserAction] = useState(null);
  const [editable, setEditable] = useState(false);
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (props.list) {
      let rows = props.list?.length ? props.list : [props.currentRow];
      setCurrentDetails(rows);
      setList(rows);
      setEditable(true);
      console.log('locations' + locations);
      // generate the boxID and SRNo distribution on initial page load
      setskuList(generateSku_list(list));
    }
  }, [props.list, brotherPrinterSdk]); // when modal is opened from SSD page

  // set up the brother printer sdk
  useEffect(() => {
    if (!brotherPrinterSdk) {
      const sdk = new BrotherSdk({
        templatePath: templatePath,
        exportDir: './exports/',
      });

      setBrotherPrinterSdk(sdk);
      refreshPrinter(sdk);
    }
  }, [brotherPrinterSdk, printLabelButtonEnabled]);

  useEffect(() => {
    if (props.currentRow) {
      let row = props.currentRow;
      setCurrentDetails([props.currentRow]);
      setInitRequestComment(row.Comments);
      setComment(row.Comments);
      setEditable(
        row.Status === TRANSACTION_STATUS.OPEN.DB_STATUS ? true : false
      );

      // set transaction modal to readonly if the order is created in GEEK+ system
      // and disable 'Send to Geek+' action
      if (
        !IsRole(['Admin', 'Material Manager']) ||
        [
          TRANSACTION_STATUS.GIVEIT.DB_STATUS,
          TRANSACTION_STATUS.PTOCRE.DB_STATUS,
        ].includes(row.Status)
      ) {
        setReadOnly(true);
      } else {
        setReadOnly(false);
      }

      if (row && row.Transaction_DBID) {
        setTrId(row.Transaction_DBID);

        Api({
          sp: 'getTransactionListData',
          json: {
            transactionId: row.Transaction_DBID,
          },
        }).then((response) => {
          setskuList(initializeSkus(response));
        });
      }
    }
  }, [props.currentRow]); // when modal is opened from Transacation Page

  const refreshPrinter = (sdk) => {
    sdk
      .getPrinterName()
      .then((printer) => {
        toast.success(`Found Brother printer ${printer}`);
        setBrotherPrinterFound(true);
      })
      .catch((err) => {
        toast.error(`Could not find Brother printer: ${err}`);
        setBrotherPrinterFound(false);
      });
  };

  const printLabels = async () => {
    if (!brotherPrinterSdk) {
      toast.error('Could not connect to printer');
      return;
    }

    // disable the label printing button to prevent double-clicks
    setPrintLabelButtonEnabled(false);

    try {
      for (const sku of skuList) {
        const boxId = sku['boxId'];
        const transactionId = trId ?? 'Unknown';
        const barcode = `${transactionId.toString().padStart(8, '0')}-${boxId.toString().padStart(3, '0')}`;
        const fullTransactionId = barcode;

        const data = {
          boxId: boxId.toString(),
          transactionId: transactionId.toString(),
          barcode: barcode,
          fullTransactionId: fullTransactionId,
        };

        const options = {
          copies: 1,
          printName: `label-${barcode}`,
        };

        await brotherPrinterSdk.print(
          JSON.parse(JSON.stringify(data)),
          JSON.parse(JSON.stringify(options))
        );
      }

      toast.success('Label(s) printed!');
    } catch (err) {
      toast.error(`Error printing labels: ${err}`);
    } finally {
      setPrintLabelButtonEnabled(true);
    }
  };

  const setCurrentDetails = (rows) => {
    Api({
      sp: 'getUsers',
      json: {},
    }).then((users) => {
      setCurrentOwner(
        users.find(
          (user) => user.User_DBID === parseInt(rows[0]?.EntityOwner) ?? '-1'
        )
      );
      setUsers(users);

      Api({
        sp: 'getNonMaterialPaths',
        json: {},
      }).then((parents) => {
        setLocations(parents);
        let entityPath = rows[0]?.Path;
        let found = rows.find((row) => !row?.Path || row?.Path !== entityPath);

        setCurrentLocation(
          found
            ? { Path: 'Multiple Locations' }
            : parents.find((parent) => {
                if (parent && parent?.Path)
                  return parent.Path.trim() === entityPath?.trim();
              })
        );
      });
    });
  };

  const close = (refresh) => {
    props.close(refresh);
  };

  const handleBuildIdChange = (buildId, i) => {
    let skus = [...skuList];
    let all = [...buildIds];

    skus[i].buildId = buildId;
    skus[i].ent = [];
    skus[i].obj = [];

    let selected = [];
    for (const sku of skus) {
      selected.push(sku.buildId);
    }
    const remaining = all.filter((id) => !selected.includes(id));
    setRemainingBuildIds(remaining);

    updateSrNos(skus);
    setskuList(skus);
  };

  const updateSrNos = (skus) => {
    let selectList = [];
    let all = [...allSrNos];

    for (const sku of skus) {
      selectList.push(...sku['obj']);
    }

    const remaining = all.filter(
      (obj1) => !selectList.some((obj2) => obj1.id === obj2.id)
    );

    setSelectedSrNos(selectList);
    setRemainingSrNos(remaining);
    updateBoxFlag(skus);
    updateSaveButtonFlag(skus);
    if (updateFlag === null) {
      setUpdateFlag(1);
    }
  };

  const handleSrNoChange = (list, i, res, srNo) => {
    console.log(res, srNo);
    let skus = [...skuList];
    skus[i].obj = [...list]; // update sku.ent and the list of remaining ids based on res here

    updateSrNos(skus);
    setskuList(skus);
  };

  /** This method will merge newly entered serial numbers to the existing list */
  const addSrNoToList = (list, i) => {
    let skus = [...skuList];

    let remainingSrNosByBuild = remainingSrNos.filter(
      (obj) => skus[i].buildId === obj.buildId
    );
    let newList = remainingSrNosByBuild.filter((SrNo) =>
      list.some((sr) => sr.toLowerCase() == SrNo.srNo.toLowerCase())
    );
    skus[i].obj = [...skus[i].obj, ...newList];

    updateSrNos(skus);
    setskuList(skus);
  };

  const addAll = (i, sku) => {
    let list = remainingSrNos.filter((sr) => sr.buildId === sku.buildId);
    let skus = [...skuList];
    skus[i].obj = [...skus[i].obj, ...list];
    updateSrNos(skus);
    setskuList(skus);
  };

  const disableAddAll = (sku) => {
    let list = remainingSrNos.filter((sr) => sr.buildId === sku.buildId);

    if (list.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const initializeSkus = (rows) => {
    let skus = [];
    let objs = [];
    let buildIds = [];

    outerLoop: for (const row of rows) {
      let found = 0;
      for (const sku of skus) {
        if (sku['boxId'] == row['Box_Num']) {
          sku['obj'].push({
            buildId: row['Build ID'],
            srNo: row['Serial Number'],
            id: row['Entity_DBID'],
          });
          objs.push({
            buildId: row['Build ID'],
            srNo: row['Serial Number'],
            id: row['Entity_DBID'],
          });
          found = 1;
          continue outerLoop;
        }
      }
      if (!found) {
        let newSku = {
          boxId: row['Box_Num'],
          buildId: row['Build ID'],
          obj: [
            {
              buildId: row['Build ID'],
              srNo: row['Serial Number'],
              id: row['Entity_DBID'],
            },
          ],
          isNew: 0,
        };

        buildIds.push(row['Build ID']);
        objs.push({
          buildId: row['Build ID'],
          srNo: row['Serial Number'],
          id: row['Entity_DBID'],
        });
        skus = [...skus, newSku];
      }
    }

    setBuildIds(buildIds);
    setSelectedBuildIds(buildIds);
    setRemainingBuildIds([]);
    setAllSrNos(objs);

    setSelectedSrNos(objs);
    setRemainingSrNos([]);

    skus.sort((a, b) => a.boxId - b.boxId);

    updateSaveButtonFlag(skus);
    setInitSkuList([...skus]);
    return skus;
  };
  const generateSku_list = (rows) => {
    let skus = [];
    let objs = [];
    let buildIds = [];
    outerLoop: for (const row of rows) {
      let found = 0;
      for (const sku of skus) {
        if (sku['buildId'] == row['Build ID'][0]) {
          sku['obj'].push({
            buildId: row['Build ID'][0],
            srNo: row['Serial Number'][0],
            id: row['Entity_DBID'],
          });
          objs.push({
            buildId: row['Build ID'][0],
            srNo: row['Serial Number'][0],
            id: row['Entity_DBID'],
          });
          found = 1;
          continue outerLoop;
        }
      }
      if (!found) {
        let newSku = {
          boxId: skus.length + 1,
          buildId: row['Build ID'][0],
          ent: [row['Entity_DBID']],
          obj: [
            {
              buildId: row['Build ID'][0],
              srNo: row['Serial Number'][0],
              id: row['Entity_DBID'],
            },
          ],
          isNew: 0,
        };

        buildIds.push(row['Build ID'][0]);
        objs.push({
          buildId: row['Build ID'][0],
          srNo: row['Serial Number'][0],
          id: row['Entity_DBID'],
        });
        skus = [...skus, newSku];
      }
    }
    setBuildIds(buildIds);
    setSelectedBuildIds(buildIds);
    setRemainingBuildIds([]);
    setAllSrNos(objs);
    console.log('remainig build' + JSON.stringify(remainingBuildIds));
    console.log('selected build' + JSON.stringify(selectedBuildIds));

    setSelectedSrNos(objs);
    setRemainingSrNos([]);
    skus.sort((a, b) => a.boxId - b.boxId);
    updateSaveButtonFlag(skus);
    setInitSkuList([...skus]);
    return skus;
  };

  const addBox = () => {
    let skus = [...skuList];
    skus.push({ boxId: skus.length + 1, buildId: '', ent: [], obj: [] });
    updateBoxFlag(skus);
    setskuList(skus);
  };

  const removeBox = (i) => {
    let skus = [...skuList];
    skus.splice(i, 1);
    skus = updateBoxNums(skus);
    updateSrNos(skus);
    updateBoxFlag(skus);
    setskuList(skus);
  };

  const updateBoxNums = (skus) => {
    let i = 1;
    for (const sku of skus) {
      sku['boxId'] = i;
      i++;
    }
    return skus;
  };

  const updateSkus = (skus) => {
    for (const sku of skus) {
      sku['ent'] = sku['obj'].map((s) => s.id);
    }

    if (initSkuList.length < skus.length) {
      let diff = skus.length - initSkuList.length;
      let j = 1;
      for (let i = diff; i > 0; i--) {
        skus[skus.length - j].isNew = 1;
        j = 1;
      }
    }
    return skus;
  };

  const savePTO = () => {
    setUserAction('save');

    if (remainingSrNos.length > 0) {
      setReadOnly(true);
      setErrorModal(true);
    } else {
      performSave();
    }
  };

  const performSave = (sendOut = false) => {
    setReadOnly(true);
    let newOwner = undefined;
    newOwner = users.find((user) => user.UserName === 'Material Storage');

    let skus = updateSkus([...skuList]);
    let finalJSON = {
      currentOwnerId: currentOwner.User_DBID,
      currentParentId: currentLocation.Entity_DBID,
      ownerId: newOwner.User_DBID,
      parentId: parseInt(bake({ key: 'materialStorageId' }), 10),
      matType: 'SSD',
      ids: selectedSrNos.map((srNo) => srNo.id),
      total: selectedSrNos.length,
      comment: initRequestComment === comment ? null : comment,
      sku_list: skus,
      sendToGeek: sendOut,
      skipBoxUpdate: sendOut && props.currentRow?.Status.includes('Error'), // when PTO is in Erro state
      isGeek: 1,
      stagingParentId: parseInt(bake({ key: 'materialStaging' }), 10),
      geekTrId: trId, // TODO: rename geekTrId to trId in param
      updateFlag: updateFlag,
    };

    let message = trId === undefined ? ' created' : ' updated';
    GeekApi('ptocre', finalJSON)
      .then((response) => {
        toast.success(
          TRANSACTION_STATUS.GIVEIT.DESCRIPTION +
            ' ' +
            String(response[0].id).padStart(8, 0) +
            message
        );

        let subject = sendOut
          ? TRANSACTION_STATUS.GIVEIT.DESCRIPTION
          : TRANSACTION_STATUS.GIVEIT.DESCRIPTION +
            ' (' +
            TRANSACTION_STATUS.OPEN.DESCRIPTION +
            ')';
        SendEmail('instantEmailGiveGotRequest', {
          emailSubject:
            subject + ' ' + response[0].id.toString().padStart(8, '0'),
          transactionId: response[0].id,
          action: TRANSACTION_STATUS.GIVEIT.DB_STATUS,
        });
        close(true);
      })
      .catch((error) => {
        toast.error(error.message);
        close(true);
      });
  };

  const createPTO = () => {
    setUserAction('create');
    if (remainingSrNos.length > 0) {
      setReadOnly(true);
      setErrorModal(true);
    } else {
      performSave(true);
    }
  };

  const handleComments = (val) => {
    setComment(val);
  };

  const updateBoxFlag = (recentSkus) => {
    let skus = recentSkus.length !== 0 ? recentSkus : [...skuList];
    let flag = skus.some((sku) => {
      return sku.obj.length === 0;
    });
    setNewBoxFlag(!flag);
  };

  const updateSaveButtonFlag = (recentSkus) => {
    let skus = recentSkus.length !== 0 ? recentSkus : [...skuList];

    setDisableSave(
      skus.some((sku) => {
        return sku.obj.length === 0;
      })
    );
  };
  const clearRemainingSrs = () => {
    setReadOnly(false);
    setErrorModal(false);
    setRemainingSrNos([]);
    if (userAction === 'save') {
      performSave();
    } else {
      performSave(true);
    }
  };
  const workOnRemainingSrs = () => {
    setReadOnly(false);
    setErrorModal(false);
  };

  return (
    <>
      <Modal
        show={props.show}
        onHide={() => close(true)}
        className={errorModal ? 'entity-modal fade-pto' : 'entity-modal'}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton={errorModal ? false : true}>
          <Modal.Title>
            {props.title} {trId ? '' + trId : ''}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-2">
            <div>
              <b>Current Owner: </b> {currentOwner?.UserName}
            </div>
            <div>
              <b>Current Location: </b> {currentLocation?.Path}
            </div>
          </div>
          <div className="box-container">
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Add Box"
            >
              <Button
                className="icon-btn"
                type="radio"
                variant="outline-primary"
                onClick={() => addBox()}
                disabled={!editable || !newBoxFlag || readOnly}
              >
                <PlusLg className="export" size={20} />
              </Button>
            </Hint>
          </div>
          <div>
            <table className="pto-tab">
              <thead className="pto-tab-head">
                <tr>
                  <th className="boxno-pto">BoxNo</th>
                  <th className="buildid-pto">BuildID</th>
                  <th className="srno-pto">SerialNo(s)</th>
                  <th className="action-all"></th>
                  <th className="action-pto"></th>
                </tr>
              </thead>
              <tbody className="pto-tab-body">
                {skuList.map((sku, i) => {
                  return (
                    <tr key={i}>
                      <td className="boxno-pto">
                        {' '}
                        <div>
                          {/* {trId} */}
                          {String(sku.boxId).padStart(3, '0')}
                        </div>
                      </td>
                      <td className="buildid-pto">
                        <div>
                          <Autocomplete
                            autoHighlight={true}
                            className="type-ahead"
                            id="parent-entity"
                            options={buildIds}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Select..."
                              />
                            )}
                            disabled={!editable || readOnly}
                            onChange={(_event, list, res, buildId) => {
                              handleBuildIdChange(list, i, res, buildId);
                            }}
                            value={sku.buildId || undefined}
                          />
                        </div>
                      </td>
                      <td className="srno-pto">
                        <div>
                          <Autocomplete
                            multiple
                            autoHighlight={true}
                            className="type-ahead"
                            disabled={!editable || readOnly}
                            options={remainingSrNos.filter(
                              (sr) => sr.buildId === sku.buildId
                            )}
                            getOptionLabel={(option) => option.srNo}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                placeholder={sku.obj.length + ' Selected'}
                              />
                            )}
                            onChange={(_event, list, res, srNo) => {
                              handleSrNoChange(list, i, res, srNo);
                            }}
                            value={sku.obj || []}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' && e.target.value) {
                                let text = e.target.value;
                                if (text.includes(' ')) {
                                  let list = text
                                    .split(' ')
                                    .map((x) => x.trim());
                                  addSrNoToList(list, i);
                                } else {
                                  addSrNoToList([text.trim()], i);
                                }
                              }
                            }}
                          />
                        </div>
                      </td>
                      <td className="action-all">
                        <Hint
                          placement="top"
                          delay={{
                            show: 250,
                            hide: 400,
                          }}
                          title="Select All"
                        >
                          <span>
                            <Button
                              className="icon-btn add-btn"
                              type="radio"
                              variant="outline-primary"
                              onClick={() => {
                                addAll(i, sku);
                              }}
                              disabled={disableAddAll(sku) || readOnly}
                            >
                              <CheckAll className="export" size={15} />
                            </Button>
                          </span>
                        </Hint>
                      </td>
                      <td className="action-pto">
                        <div>
                          {skuList.length > 1 ? (
                            <Trash
                              color="red"
                              className="pointer"
                              onClick={() => removeBox(i)}
                              disabled={!editable || readOnly}
                              size={18}
                            />
                          ) : (
                            ''
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="mb-2">
            <h6>Comments</h6>
            <Form.Control
              className="w-100 overflow-hidden"
              as="textarea"
              rows="1"
              placeholder="Type..."
              onChange={(e) => handleComments(e.target.value)}
              value={comment}
              disabled={readOnly}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="outer">
            <div className="print">
              <Button
                onClick={() => printLabels()}
                disabled={
                  readOnly ||
                  trId == null ||
                  !brotherPrinterFound ||
                  !printLabelButtonEnabled
                }
              >
                Print Label(s)
              </Button>
            </div>
            <div className="confirm">
              <Button
                variant="primary"
                onClick={() => savePTO()}
                disabled={disableSave || readOnly}
              >
                Save PTO
              </Button>
              <Button
                variant="primary"
                onClick={() => createPTO()}
                disabled={disableSave || readOnly}
              >
                Send to Geek+
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {errorModal ? (
        <Modal show={errorModal} onHide={() => close(true)} backdrop="static">
          <ModalBody>
            <p>Are you sure you dont want to save remaining Serial Numbers?</p>
            <ul>
              {remainingSrNos.map((srN, i) => {
                return <li key={i}>{srN.srNo}</li>;
              })}
            </ul>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => clearRemainingSrs()}>Yes</Button>
            <Button onClick={() => workOnRemainingSrs()}>No</Button>
          </ModalFooter>
        </Modal>
      ) : null}
    </>
  );
}
